module.exports = __webpack_public_path__ + "static/media/twitter.90c900c3.svg";